import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { asyncAddTemplateTest } from '../add-template-test/add-template-test.actions';
import { asyncFetchTemplateTest } from './duplicate-template-test.actions';

import DuplicateTemplateTestPresentation from './duplicate-template-test-presentation';

class DuplicateTemplateTest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            labelTest: '',
            typeTest: '',
            maxDuration: 5,
            amountQuestion: 1,
            minOptions: 2,
            maxOptions: 2,
            percentual: 0,
            formReady: false,
            showQuestions: false,
            questionsAddeds: [],
        };
    }

    componentDidMount() {
        const {
            match: {
                params: { test_id: testId },
            },
            asyncFetchTemplateTest,
        } = this.props;
        asyncFetchTemplateTest({ testId });
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            labelTest,
            typeTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            amountQuestion,
        } = this.state;
        const { test, questions } = this.props;

        if (prevProps.test !== test) {
            this.setState({
                labelTest: test.label+' - (Cópia)',
                typeTest: test.test_type,
                maxDuration: test.max_duration / 60,
                amountQuestion: test.questions_per_test,
                minOptions: test.min_options,
                maxOptions: test.max_options,
                percentual: test.approval_percent,
            });
        }

        if (prevProps.questions !== questions) {
            this.setState({
                questionsAddeds: questions.map(question => question.id),
            });
        }

        if (
            prevState.labelTest !== labelTest ||
            prevState.typeTest !== typeTest ||
            prevState.maxDuration !== maxDuration ||
            prevState.minOptions !== minOptions ||
            prevState.maxOptions !== maxOptions ||
            prevState.amountQuestion !== amountQuestion ||
            prevState.percentual !== percentual
        ) {
            this.checkForm();
        }
    }

    handleChangeInput(target) {
        const { questionsAddeds } = this.state;
        const { questions } = this.props;
        let newQuestionsAdd = [];
        for(const e of questionsAddeds){
            let currentQuestions = questions.find(question=> question.id === e);
            if(currentQuestions){
                if(!(currentQuestions.options > target.value)){
                    newQuestionsAdd.push(e)
                }
            }
        }
        this.setState({ [target.name]: target.value, questionsAddeds: newQuestionsAdd });
    }

    checkForm() {
        const {
            labelTest,
            typeTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            amountQuestion,
        } = this.state;

        const formIsOk =
            labelTest !== '' &&
            typeTest !== '' &&
            Number(maxDuration) >= 5 &&
            Number(maxDuration) <= 480 &&
            Number(amountQuestion) >= 1 &&
            Number(amountQuestion) <= 256 &&
            Number(maxOptions) >= 2 &&
            Number(maxOptions) <= 20 &&
            Number(minOptions) >= 2 &&
            Number(minOptions) <= Number(maxOptions) &&
            Number(percentual) > 0 &&
            Number(percentual) <= 100;
        this.setState({ formReady: formIsOk });
    }

    handleSubmit(ev) {
        ev.preventDefault();

        const {
            labelTest,
            typeTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            questionsAddeds,
            amountQuestion,
        } = this.state;
        const { asyncAddTemplateTest } = this.props;

        const maxDurationInSeconds = maxDuration * 60;
        asyncAddTemplateTest({
            labelTest,
            typeTest,
            maxDuration: maxDurationInSeconds,
            minOptions,
            maxOptions,
            percentual,
            createNewTest: false,
            amountQuestions: amountQuestion,
            questions: questionsAddeds,
        });
    }

    handleShowQuestions(current) {
        this.setState({ showQuestions: !current });
    }

    handleHandleQuestionsAdd(newQuestionsAddeds) {
        this.setState({ questionsAddeds: newQuestionsAddeds });
    }

    checkDisableQuestionFn(question) {
        const { minOptions, maxOptions } = this.state;
        let questionDisabled = false;
        const amountEnabledItems = question.options.filter(
            option => option.enabled,
        ).length;
        if (
            !questionDisabled &&
            (amountEnabledItems < minOptions || amountEnabledItems > maxOptions)
        ) {
            questionDisabled = true;
        }

        return questionDisabled;
    }

    render() {
        const {
            labelTest,
            typeTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            formReady,
            showQuestions,
            questionsAddeds,
            amountQuestion,
        } = this.state;
        const { loading } = this.props;

        return (
            <DuplicateTemplateTestPresentation
                labelTest={labelTest}
                typeTest={typeTest}
                maxDuration={maxDuration}
                minOptions={minOptions}
                maxOptions={maxOptions}
                amountQuestion={amountQuestion}
                percentual={percentual}
                formReady={formReady}
                handleChangeInput={this.handleChangeInput.bind(this)}
                handleSubmit={this.handleSubmit.bind(this)}
                loading={loading}
                showQuestions={showQuestions}
                handleShowQuestions={this.handleShowQuestions.bind(this)}
                handleHandleQuestionsAdd={this.handleHandleQuestionsAdd.bind(
                    this,
                )}
                questionsAddeds={questionsAddeds}
                checkDisableQuestionFn={this.checkDisableQuestionFn.bind(this)}
            />
        );
    }
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = ({ onlineTests, duplicateTemplateTest }) => ({
    loading: onlineTests.loading,
    test: duplicateTemplateTest.test,
    questions: duplicateTemplateTest.questions,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            asyncAddTemplateTest,
            asyncFetchTemplateTest,
        },
        dispatch,
    );

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(DuplicateTemplateTest),
);



// WEBPACK FOOTER //
// ./src/components/duplicate-template-test/duplicate-template-test.js